export default __webpack_public_path__ + "static/media/Frame_191.86d87e86.jpg";